import { useRecoilValue } from 'recoil';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import BootstrapNav from 'react-bootstrap/Nav';

import * as K from 'common/constants';
import ELEMENT from 'common/element';
import { logoState, navbarVariantState } from 'components/common/Managers/SettingsManager.state';
import Button, { ButtonVariant } from 'components/common/Button/Button';

import './PublicNavBar.scss';

function PublicNavBar(): JSX.Element {
  const isLoginPage = window.location.pathname.includes(K.ROUTE.LOG_IN);
  const { logoUrl, logoWidth } = useRecoilValue(logoState);
  const navbarVariant = useRecoilValue(navbarVariantState);
  // TBD - FRONT-7307 Temporarily disable "Try it Free" option for new domains
  const isNewDomain = K.NEW_DOMAINS.includes(window.location.hostname);

  return (
    <BootstrapNavbar expand="lg" className="navbar-scalyr" variant={navbarVariant}>
      <BootstrapNavbar.Brand href="/?welcome=1">
        <img alt={K.PRODUCT_NAME} src={logoUrl} data-test-id={ELEMENT.navScalyrLogo} style={{ width: logoWidth }} />
      </BootstrapNavbar.Brand>

      <BootstrapNavbar.Toggle />
      <BootstrapNavbar.Collapse>
        <BootstrapNav className="Navbar--MainTabs mr-auto">
          <BootstrapNav.Item>
            <BootstrapNav.Link href="https://www.dataset.com/platform/">Features</BootstrapNav.Link>
          </BootstrapNav.Item>

          <BootstrapNav.Item>
            <BootstrapNav.Link href="https://www.dataset.com/pricing/">Pricing</BootstrapNav.Link>
          </BootstrapNav.Item>

          <BootstrapNav.Item>
            <BootstrapNav.Link href="/help">Documentation</BootstrapNav.Link>
          </BootstrapNav.Item>

          <BootstrapNav.Item>
            <BootstrapNav.Link href="https://www.dataset.com/contact/">Contact</BootstrapNav.Link>
          </BootstrapNav.Item>
        </BootstrapNav>

        <BootstrapNav className="PublicNavBar__Actions">
          {!isLoginPage && (
            <Button variant={ButtonVariant.BORDERLESS} href={K.ROUTE.LOG_IN}>
              Login
            </Button>
          )}
          {!isNewDomain && (
            <Button variant={ButtonVariant.PRIMARY} href={K.LINK.SIGN_UP}>
              Try it Free
            </Button>
          )}
        </BootstrapNav>
      </BootstrapNavbar.Collapse>
    </BootstrapNavbar>
  );
}

export default PublicNavBar;
